import React, {Component} from 'react';
import {Sticky, StickyContainer} from 'react-sticky';
import {Col, Container, Row} from 'reactstrap';
import {Link, animateScroll as scroll} from 'react-scroll';
import classNames from 'classnames';
import './SalesNav.scss';

export default function SalesNav(props) {
  return (
    <div className={classNames(`ppt-nav d-none d-lg-block`, props.className)}>
      <Container>
        <Row>
          <Col>
            <div className="ppt-nav-list">
              <Link
                className="ppt-nav-list-item"
                activeClass="active"
                spy={true}
                offset={-55}
                to="intro"
                smooth={true}
                href="#"
              >
                Why This Program
              </Link>
              <Link
                className="ppt-nav-list-item"
                activeClass="active"
                spy={true}
                offset={-55}
                to="hosts"
                smooth={true}
                href="#"
              >
                Instructor Profile
              </Link>
              <Link
                className="ppt-nav-list-item"
                activeClass="active"
                spy={true}
                offset={-55}
                to="learn"
                smooth={true}
                href="#"
              >
                What You'll Learn
              </Link>
              <Link
                className="ppt-nav-list-item"
                activeClass="active"
                spy={true}
                offset={-55}
                to="bonuses"
                smooth={true}
                href="#"
              >
                Bonuses
              </Link>
              <Link
                className="ppt-nav-list-item"
                activeClass="active"
                spy={true}
                offset={-55}
                to="enroll"
                smooth={true}
                href="#"
              >
                Enroll Now
              </Link>
              <Link
                className="ppt-nav-list-item"
                activeClass="active"
                spy={true}
                offset={-55}
                to="faqs"
                smooth={true}
                href="#"
              >
                FAQs
              </Link>
              <Link
                className="ppt-nav-list-item"
                activeClass="active"
                spy={true}
                offset={-55}
                to="testimonials"
                smooth={true}
                href="#"
              >
                What Students Say
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
